<template>
  <BTable
    class="BTableCollectorPublications"
    v-bind="$attrs"
    :selected="value"
    :headers="headers"
    :actions="actions"
    :list="list"
    v-on="$listeners || {}"
  >
    <template #item.session="{ header, item, value: v }">
      <span
        v-if="header.getSessionNames"
        v-text="header.getSessionNames(item, sessions)"
      />
      <template v-else>
        {{ v }}
      </template>
    </template>
  </BTable>
</template>

<script>
import { TABLE_HEADERS, TABLE_ACTIONS } from '@/views/Procedures/table-headers'
import BTableSimple from './BTableSimple.vue'

export default {
  name: 'BTableProcedures',
  extends: BTableSimple,
  props: {
    value: Array,
    headers: {
      type: Array,
      default: () => TABLE_HEADERS,
    },
    actions: {
      type: Array,
      default: () => TABLE_ACTIONS,
    },
    sessions: {
      type: Array,
      default: () => [],
    },
  },
}
</script>
